module.exports = __webpack_public_path__ + "img/flight-JT-lion-circle.09c4470c.svg";